import { faL } from "@fortawesome/free-solid-svg-icons"
import {
  GET_ACCESSPROFILE_START,
  GET_ACCESSPROFILE_FAILURE,
  GET_ACCESSPROFILE_SUCCESS,
  CREATE_ACCESSPROFILE_START,
  CREATE_ACCESSPROFILE_FAILURE,
  CREATE_ACCESSPROFILE_SUCCESS,
  CREATE_ACCESSPROFILE_RESET,
  GET_ROUTES_START,
  GET_ROUTES_FAILURE,
  GET_ROUTES_SUCCESS,
  ASSIGN_ROUTES_START,
  ASSIGN_ROUTES_SUCCESS,
  ASSIGN_ROUTES_FAILURE,
  ASSIGN_ROUTES_RESET,
  GET_EMPROUTES_START,
  GET_EMPROUTES_FAILURE,
  GET_EMPROUTES_SUCCESS,
  GET_ACCESSEMPLOYEE_START,
  GET_ACCESSEMPLOYEE_SUCCESS,
  GET_ACCESSEMPLOYEE_FAILURE,
  GET_ACCESSEMPLOYEE_RESET,
  UPDATE_ACCESSPROFILE_START,
  UPDATE_ACCESSPROFILE_SUCCESS,
  UPDATE_ACCESSPROFILE_FAILURE,
  GET_OTHER_ROUTES,
  GET_OTHER_ROUTES_SUCCESS,
  GET_OTHER_ROUTES_FAILED,
  UPDATE_OTHER_ROUTES,
  UPDATE_OTHER_ROUTES_FAILED,
  UPDATE_OTHER_ROUTES_SUCCESS,
  GETMY_OTHER_ROUTES,
  GETMY_OTHER_ROUTES_FAILED,
  GETMY_OTHER_ROUTES_SUCCESS,



} from "./actionTypes"

const initialState = {
  loading: false,
  isCreated: false,
  isAssigned: false,
  errors: "",
  msg: "",
  roles: [],
  Profile: [],
  routes: [],
  Assignedroles: [],
  myroutes: [],
  emp: [],
  otherRoutes: [],
  myOtherRoutes: []
}

const AccessProfilereducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ACCESSPROFILE_START:
      return {
        ...state,
        loading: true,
        isCreated: false,
        msg: null,
      }
    case CREATE_ACCESSPROFILE_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        isCreated: true,
        roles: action.payload,
        msg: action.payload.message,
      }
    case CREATE_ACCESSPROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        isCreated: false,
      }
    case CREATE_ACCESSPROFILE_RESET:
      return {
        ...state,
        isCreated: false,
        loading: false,
        errors: "",
        roles: [],
      }
    case GET_ACCESSPROFILE_START:
      return {
        ...state,
        loading: true,
        errors: "",
        msg: ""
      }
    case GET_ACCESSPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        Profile: action.payload
      }
    case GET_ACCESSPROFILE_FAILURE:
      console.log(action.payload.message)
      return {
        ...state,
        loading: false,
        errors: action.payload.message,
      }


    case GET_ROUTES_START:
      return {
        ...state,
        loading: true,
        errors: "",
        msg: ""
      }
    case GET_ROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        routes: action.payload
      }
    case GET_ROUTES_FAILURE:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        errors: action.payload.message,
      }


    case ASSIGN_ROUTES_START:
      return {
        ...state,
        loading: true,
        isAssigned: false,
      }
    case ASSIGN_ROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        isAssigned: true,
        roles: action.payload,
      }
    case ASSIGN_ROUTES_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        isAssigned: false,
      }
    case ASSIGN_ROUTES_RESET:
      return {
        ...state,
        isAssigned: false,
        loading: false,
        errors: "",
        Assignedroles: [],
      }

    case GET_EMPROUTES_START:
      return {
        ...state,
        loading: true,
        errors: "",
        myroutes: [],
        msg: ""
      }
    case GET_EMPROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        myroutes: action.payload
      }
    case GET_EMPROUTES_FAILURE:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        errors: action.payload.message,
      }


    case GET_ACCESSEMPLOYEE_START:
      return {
        ...state,
        loading: true,
        errors: "",
        msg: ""
      }
    case GET_ACCESSEMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        emp: action.payload.result,
      }
    case GET_ACCESSEMPLOYEE_FAILURE:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        errors: action.payload.message,
      }

    case UPDATE_ACCESSPROFILE_START:
      return {
        ...state,
        loading: true
      }
    case UPDATE_ACCESSPROFILE_SUCCESS:
      console.log(action.payload)
      console.log("action.payload")
      return {
        ...state,
        loading: false,
        msg: action.payload.message
      }
    case UPDATE_ACCESSPROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.message
      }
    case GET_OTHER_ROUTES:
    case UPDATE_OTHER_ROUTES:
    case GETMY_OTHER_ROUTES:
      return {
        ...state,
        loading: true,
        errors: "",
        msg: ""
      }
    case GET_OTHER_ROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        otherRoutes: action.payload.Routes,

      }

    case GET_OTHER_ROUTES_FAILED:
    case UPDATE_OTHER_ROUTES_FAILED:
    case GETMY_OTHER_ROUTES_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.payload,

      }
    case UPDATE_OTHER_ROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        msg: action.payload

      }

    case GETMY_OTHER_ROUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        myOtherRoutes: action.payload

      }
    default:
      return state
  }
}

export default AccessProfilereducer
